<template>
    <v-dialog
        v-model="dialog"
        persistent
        z-index="9999"
        max-width="550"
    >
        <v-alert
                prominent
                type="error"
        >
            <v-row align="center">
                <v-col class="grow">
                    <strong>{{ $t(error.title) }}</strong><br>
                    <p
                        v-if="error.textTranslate"
                        v-text="$t(error.text).replace(/\n/g, '<br>')"
                    ></p>
                    <p
                        v-else
                        v-text="error.text"
                    ></p>
                </v-col>
                <v-col class="shrink">
                    <v-btn
                        text
                        @click="abort"
                    >
                        <v-icon left>mdi-cancel</v-icon> {{ $t('controls.ok') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
    </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Error',
    computed: {
      ...mapGetters({
        error: 'error/getError'
      }),
      dialog: {
        get() {
          return this.error.show
        },
        set() {
          this.$store.commit('error/closeError')
        }
      }
    },
    methods: {
      abort () {
        if (this.error.abortCallback)
          this.error.abortCallback()

        this.$store.commit('error/closeError')
      },
    }
  }
</script>

<style lang="scss">
    .v-alert {
        margin-bottom: 0;

        button {
            background-color: rgba(255, 255, 255, .2);
        }
    }
</style>
